var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.assetsList),function(asset,i){return _c('div',{key:asset.name},[_c('download-row',{attrs:{"asset":asset,"index":i + 1},on:{"success":_vm.success,"removeAsset":_vm.removeAsset}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }